import { Box } from '@mui/material'
import type { FC } from 'react'

import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import EscalateApplicantForm from '@/components/Escalation/Form'
import H2 from '@/components/H2'
import useUser from '@/hooks/useUser'
import { editEscalationMutation } from '@/lib/apollo'

export interface Props {
  isOpen: boolean
  onClose: () => void
  subjectId: string
  onApplicantUpdated: () => void
}

const EscalationSidebar: FC<Props> = ({
  isOpen,
  onClose,
  subjectId,
  onApplicantUpdated,
}) => {
  const [editEscalation] = editEscalationMutation.useMutation()

  const { customerId, personId } = useUser()

  return isOpen ? (
    <SlideInSidebar
      onClose={() => onClose()}
      header={<H2>De-escalate this applicant</H2>}
      content={
        <Box mt={3}>
          <EscalateApplicantForm
            isEscalation={false}
            onCancel={onClose}
            onEditEscalation={fields => {
              return editEscalation({
                variables: {
                  isEscalated: false,
                  customerId,
                  subjectId,
                  userId: personId,
                  reason: fields.reason,
                },
              }).then(onApplicantUpdated)
            }}
          />
        </Box>
      }
    />
  ) : (
    <></>
  )
}

export default EscalationSidebar
